import { initContract } from '@ts-rest/core';
const c = initContract();
export const standardsContract = c.router({
    createChat: {
        method: 'POST',
        path: '/chats',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getMessages: {
        method: 'GET',
        path: '/chats/:id/messages',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getChatById: {
        method: 'GET',
        path: '/chats/:id',
        responses: {
            200: c.type(),
        },
    },
});
//# sourceMappingURL=standards.js.map